/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-10 15:21:56                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-03-03 14:58:36                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Components
  * WorkorderListItem: Display workorder list item
*/

/* Imports */
import { t } from "i18next";
/***/

/* Components */
import { IconButton } from "@material-tailwind/react";
import { TrashIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import Loading from "../../../../components/loading/Loading";
/***/

import DeleteProspectModal from "./modals/DeleteProspectModal";
import EditCreateDrawer from "../../../../components/edit-create-drawer/EditCreateDrawer";
import ProspectForm, { ProspectFormValidator } from "../../../../components/data/prospect/ProspectForm";
import toast from "react-hot-toast";
import { showApiErrorToast } from "../../../../services/api/error";
import { api } from "../../../../services/api/api";
import { validator } from "../../../../services/form-validator/form-validator";
import { buildProspectPayload } from "../../../../services/prospect/prospect";

/**
* WorkorderListItem: Display workorder list item
* @param workorder - Workorder data
* @param onClick - On click event
* @param isLast - Is last item
*/
export default function ProspectAdminActions({
  prospect,
  onChange
}: {
  prospect: EasyTech.Prospect,
  onChange: () => void
}) {
  const [delLoad, setDelLoad] = useState<boolean>(false); 

  const deleteUser = () => {
    setDelLoad(true);
  };

  /**
  * createVisit: Create new visit event
  * @param data - visit data 
  */
  const updateVisit = (data: EasyTech.Prospect): Promise<void> => {
    return new Promise((resolve, reject) => {
      if (validator.isFormValid(data, ProspectFormValidator)) {
        api.put("users/prospects/"+data.id, buildProspectPayload(data)).then((ret) => {
          toast.success("Visit updated !");
          onChange();
          return resolve();
        }).catch((err) => {
          showApiErrorToast(err, { fallbackMessage: "Erreur lors de la mise à jour de la visite" });
          return reject(err);
        });
      } else {
        const fieldNames = {
          customer: t("common:customer"),
          contact: t("common:contact"),
          technician: t("common:technician"),
          date: t("common:date:label")
        };
        
        const errorMessage = validator.getFormErrorMessage(data, ProspectFormValidator, fieldNames, t);
        toast.error(errorMessage);
        return reject();
      }
    });
  };
  /***/

  return(
    <div className="admin-wo-actions" data-no-link>

      {(delLoad === false) ?
        <IconButton onClick={deleteUser} 
          variant="text"
          className={"icon-btn"} 
          size="sm">
          <TrashIcon className="w-[16px]"  />
        </IconButton>
      :
        <Loading size="h-4 w-4" />  
      }

      <EditCreateDrawer<EasyTech.Prospect>
        data={prospect}
        FormComponent={ProspectForm}
        entityName="visits"
        onSubmit={updateVisit}
        isNotCreatable
      />
      {delLoad &&
        <DeleteProspectModal open={delLoad} prospect={prospect} 
        onDelete={() => onChange()} onClose={() => setDelLoad(false)} /> 
      }
    </div>
  );
}
/***/
